import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  margin: 1rem 0;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed; 
  border-collapse: collapse;
  border: 1px solid #e3e3e3;
`;

export const Th = styled.th`
  padding: 0.75rem;
  width: ${({ width }) => width || '50%'};
  text-align: ${props => props.leftAlign ? 'left' : 'center'};
  background: #4b286d;
  color: #fff;
  font-family: 'HNforTELUSSA500normal', 'Helvetica Now', 'Helvetica Neue',
    Helvetica, Arial, sans-serif !important;
  font-weight: 500;
  border: 1px solid #e3e3e3;
  font-size: 1rem;
  & * { color: #fff !important; }
`;

export const SubHeading = styled.th`
  padding: 0.5rem;
  text-align: left;
  background: #d2d1d1e8;
  color: #484848;
  font-weight: 600;
  border: 1px solid #e3e3e3;
  font-size: 1rem;
`;

export const SubHeadingWithNote = styled.th`
  padding: 0.5rem;
  text-align: left;
  background: #d2d1d1e8;
  color: #484848;
  font-weight: 600;
  border: 1px solid #e3e3e3;
`;

export const SubHeadingTitle = styled.div`
  font-weight: 600;
  margin-bottom: 0.25rem;
  font-size: 1rem;
`;

export const SubHeadingNote = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  color: #666;
  line-height: 1.3;
`;

export const Td = styled.td`
  padding: 0.5rem 0.75rem;
  border: 1px solid #e3e3e3;
  width: 50%;
  /* width: ${({ width }) => width || 'auto'}; */
  text-align: ${props => props.leftAlign ? 'left' : 'center'};
  vertical-align: middle;
  font-size: 1em;
`;

export const TermRow = styled.tr`
  background-color: #fff;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const Checkbox = styled.input`
  margin: 0;
  cursor: pointer;
  transform: scale(0.9);
`;

export const PriceText = styled.span`
  font-weight: 500;
  font-size: 1em;
`;

export const DashText = styled.span`
  color: #999;
  font-weight: 500;
  font-size: 1em;
`;

export const DropdownContainer = styled.div`
  width: 100%;
  min-height: 2rem;
`;

export const DataRow = styled.tr`
  background-color: #fff;
  
  &:hover {
    background-color: #f9f9f9;
  }
`;

export const CounterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const CounterButton = styled.button`
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  transition: all 0.2s ease;

  &:hover {
    background: #e0e0e0;
    border-color: #999;
  }

  &:disabled {
    background: #f8f8f8;
    color: #ccc;
    cursor: not-allowed;
    border-color: #e0e0e0;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const CounterValue = styled.span`
  font-size: 1em;
  font-weight: 500;
  min-width: 20px;
  text-align: center;
  color: #333;
`;
